import DataManager from './DataManager';

export const SubscriptionError = {
  NotActive: 'SubscriptionNotActive'
};

function isSubscriptionActive(subscription) {
  if (!subscription) {
    return false;
  }

  if (subscription.cancelAtPeriodEnd) {
    return false;
  }

  return subscription.status === 'active' || subscription.status === 'trialing';
}

export function isSubscriptionExpired(subscription) {
  if (!subscription || !subscription.currentPeriodEnd) {
    return false;
  }

  return subscription.currentPeriodEnd * 1000 < Date.now();
}

export function isPortfolioAccessBlocked(subscription) {
  if (subscription?.status === 'none') {
    return true;
  }

  return isSubscriptionExpired(subscription);
}

export function fetchSubscription(user) {
  const dataManager = DataManager.getInstance();
  return dataManager.performOperation('getSubscription', user);
}

export function verifyActiveSubscription(user, maxAttempts = 5, delayMs = 2000) {
  return fetchSubscription(user).then((subscription) => {
    if (isSubscriptionActive(subscription)) {
      return subscription;
    }

    if (maxAttempts <= 1) {
      throw new Error(SubscriptionError.NotActive);
    }

    return new Promise((resolve) => setTimeout(resolve, delayMs))
      .then(() => verifyActiveSubscription(user, maxAttempts - 1, delayMs));
  });
}
